export default (props, e) => {
	let regexNonSpace = /\s+/g;
	e.target.value = e.target.value.replace(regexNonSpace, '');
}



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/webActions/replaceWhiteSpace.js